import { useRef, useState, LegacyRef, useCallback } from 'react';
import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper, useMediaQuery, useTheme } from '@mui/material';
import { User } from '../icons/User.icon';
import { PermissionBoundary } from '../../../../core/permissions/permission-boundary.component';

export interface UserToggleProps {
  username: string;
  onLogout(): void;
}

export function UserToggle({ username, onLogout }: UserToggleProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [open, setOpen] = useState(false);
  const anchorRef: LegacyRef<any> | null = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div ref={anchorRef} onClick={handleToggle} className="topbar-item" style={{ zIndex: 100 }}>
        <div className="btn btn-icon btn-hover-transparent-white btn-lg btn-dropdown mr-1" id="kt_quick_user_toggle">
          <span className="svg-icon svg-icon-xl">
            <User />
          </span>
        </div>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          placement="bottom-end"
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom-end' ? 'end top' : 'end bottom'
              }}
            >
              <Paper>
                <MenuList autoFocusItem={open} id="menu-list-grow">
                  <p
                    style={{
                      padding: '6px 16px',
                      whiteSpace: 'nowrap',
                      overflowWrap: 'anywhere'
                    }}
                  >
                    You are logged in as{isSmallScreen ? ':' : ' ' + username}
                  </p>
                  {isSmallScreen && (
                    <p
                      style={{
                        padding: '6px 16px',
                        whiteSpace: 'nowrap',
                        overflowWrap: 'anywhere'
                      }}
                    >
                      {username}
                    </p>
                  )}

                  {/* Only show to users with the 'internal-groundfloor' feature flag */}
                  <PermissionBoundary availableUiFeatures={['internal-groundfloor']}>
                    <MenuItem
                      component="a"
                      href="https://app-lastk-gateway-api-test.azurewebsites.net/reference"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      API documentation Here
                    </MenuItem>
                  </PermissionBoundary>

                  <MenuItem onClick={onLogout}>Sign Out</MenuItem>
                </MenuList>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </ClickAwayListener>
  );
}
